import React, { useMemo } from 'react';
import { ColorPickerField } from '../../../components/Form';
import { useFocusIdx } from '@bay-email/editor';
import { t } from '@bay-email/core';

export function BorderColor({ secondary }: { secondary?: boolean }) {
	const { focusIdx } = useFocusIdx();

	return useMemo(() => {
		return (
			<ColorPickerField
				label={t('Color')}
				secondaryLabel={secondary}
				name={`${focusIdx}.attributes.border-color`}
			/>
		);
	}, [focusIdx, secondary]);
}
